export const BUYBACK_QUOTES_FETCH_INTERVAL = 1000

export const BUYBACK_QUOTES_FETCH_TIMEOUT = 20000
